import { useTheme } from '@material-ui/core';
import React from 'react';

import { EnvHeader } from '../../common/env-header';
import { HeaderDrawerButton } from '../header-drawer-button';
import { HeaderUserName } from '../header-user-name';
import { Notifications } from '../notifications';
import { AgentHeaderActions } from './agent-header-actions';
import { agentHeaderStyles } from './agent-page.styles';

export const AgentPageHeader = () => {
    const theme = useTheme();
    return (
        <div className="flex-fixed" id="page-header">
            <EnvHeader />
            <div className="page-header-primary">
                <div className="header-left">
                    <div className="header-left-menu">
                        <HeaderDrawerButton />
                    </div>
                    <div className="header-title">Orbit</div>
                </div>
                <div className="header-right">
                    <span css={agentHeaderStyles(theme)} className="agent-page-header-actions">
                        <AgentHeaderActions />
                    </span>
                    <HeaderUserName />
                    <Notifications />
                </div>
            </div>
        </div>
    );
};
